/**
 * Settings Hub - Unified settings interface
 * Combines: System Parameters and User Settings/Preferences
 */
import React, { useState } from 'react';
import { Box, Paper, Tabs, Tab } from '@mui/material';
import {
  Tune as ParametersIcon,
  Settings as PreferencesIcon
} from '@mui/icons-material';
import ParametersPage from '../Parameters/ParametersPage';
import NotificationPreferences from '../Alerts/NotificationPreferences';

const SettingsHub: React.FC = () => {
  const [tabValue, setTabValue] = useState(0);

  return (
    <Box>
      <Paper sx={{ mb: 2 }}>
        <Tabs
          value={tabValue}
          onChange={(_, val) => setTabValue(val)}
          variant="fullWidth"
        >
          <Tab icon={<ParametersIcon />} label="System Parameters" iconPosition="start" />
          <Tab icon={<PreferencesIcon />} label="User Preferences" iconPosition="start" />
        </Tabs>
      </Paper>

      {tabValue === 0 && <ParametersPage />}
      {tabValue === 1 && <NotificationPreferences />}
    </Box>
  );
};

export default SettingsHub;
